<template>
  <div class="content-wrapper">
    <section class="content-dashboard">
      <div class="container">
        <div class="row">
          <div
            data-cy="dash"
            class="col-md-6"
          >
            <h2>Dashboard</h2>
          </div>
        </div>
        <!-- /ROW -->
        <div class="row dashboard">
          <template v-if="chartData">
            <div class="col-md-8 dashboard__graph">
              <line-chart
                v-if="datacollection"
                :chart-data="datacollection"
                :options="chartOptions"
                :height="150"
              />
            </div>
          </template>
          <template v-else>
            <div
              class="col-md-8 "
              style="height: 295px;"
            >
              <table
                class="w-100 "
                style="height: 295px;"
              >
                <tr>
                  <td class="text-center">
                    No kits found.
                  </td>
                </tr>
              </table>
            </div>
          </template>

          <div
            class="col-md-4
            dashboard__payments
            d-flex
            flex-column
            justify-content-between"
          >
            <span class="dashboard__info dashboard--primary">
              Total Kits
              <strong>{{ totalKits }}</strong>
            </span>
            <span class="dashboard__info">
              Kits this month
              <strong>{{ totalKitsThisMonth }}</strong>
            </span>
            <router-link
              class="dashboard__payments-link text-white text-underline"
              :to="{ name: 'patients' }"
            >
              View full history <i class="fa fa-angle-right" />
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="content-customers">
      <div class="container">
        <h2>Recent Reports</h2>
        <table class="table ">
          <thead>
            <tr>
              <th>Patient name</th>
              <th>Purchase Date</th>
              <th>Kit ID</th>
              <th>Report Delivery Date</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="latestKits && latestKits.length > 0">
              <tr
                v-for="kit in latestKits"
                :key="kit.id"
              >
                <td>{{ kit.patientName }}</td>
                <td>{{ formatDate(kit.purchaseDate) }}</td>
                <td>{{ kit.id }}</td>
                <td>{{ formatDate(kit.reportAvailableDate) }}</td>
                <td class="text-right">
                  <template v-if="canViewReport(kit)">
                    <router-link
                      :to="{
                        name: 'result',
                        query: {samples: [kit.sampleIdentifier]}
                      }"
                    >
                      View Report
                    </router-link>
                  </template>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  colspan="5"
                  class="text-center"
                >
                  You don't currently have any reports
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- /CONTAINER -->
    </section>
  </div>
</template>

<script>
import LineChart from '../components/LineChart'
import moment from 'moment'
import _ from 'lodash'
import kitService from '@/services/kitService'

export default {
  name: 'Home',
  components: { LineChart },
  data () {
    return {
      datacollection: null
    }
  },
  computed: {
    chartOptions () {
      return {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                userCallback: function (label) {
                  if (Math.floor(label) === label) {
                    return label
                  }
                }
              }
            }
          ]
        }
      }
    },
    user () {
      return this.$store.state.GET_USER_RESPONSE
    },
    hcp () {
      return this.$store.state.GET_HCP_RESPONSE
    },
    kits () {
      return this.$store.state.GET_KITS_RESPONSE
    },
    latestKits () {
      const ordered = _.filter(this.kits, o => {
        return o.reportAvailableDate
      })

      if (ordered) {
        ordered.sort(function compare (a, b) {
          var dateA = new Date(a.reportAvailableDate)
          var dateB = new Date(b.reportAvailableDate)
          return dateB - dateA
        })

        return _.take(ordered, 5)
      }
      return null
    },
    totalKits () {
      if (this.kits) {
        return this.kits.length
      }
      return 0
    },
    totalKitsThisMonth () {
      if (this.kits) {
        const thisMonth = _.filter(this.kits, o => {
          const today = new Date()
          const datePurchased = new Date(o.purchaseDate)
          return (
            datePurchased.getMonth() === today.getMonth() &&
            datePurchased.getFullYear() === today.getFullYear()
          )
        })

        return thisMonth.length
      }
      return 0
    },
    chartData () {
      if (this.kits && this.kits.length > 1) {
        const ordered = this.kits
        ordered.sort(function compare (a, b) {
          var dateA = new Date(a.purchaseDate)
          var dateB = new Date(b.purchaseDate)
          return dateA - dateB
        })

        const groupedKit = _.groupBy(ordered, function (item) {
          return moment(item.purchaseDate).format('MMM YYYY')
        })

        return groupedKit
      }
      return null
    }
  },
  mounted () {
    this.$store.dispatch('getKits').then(() => {
      this.fillData()
    })
  },
  methods: {
    formatDate (date) {
      if (date) {
        return moment(date).format('D/M/YYYY')
      }
      return ''
    },
    fillData () {
      if (this.chartData) {
        const data = []
        for (const month in this.chartData) {
          data.push(this.chartData[month].length)
        }

        this.datacollection = {
          labels: Object.keys(this.chartData),
          datasets: [
            {
              label: 'Referral Code Usage',
              backgroundColor: '#9177c4',
              data: data
            }
          ]
        }
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * (12 - 5 + 1)) + 5
    },
    canViewReport (kit) {
      return kitService.canViewReport(kit)
    }
  }
}
</script>
<style>
.text-underline {
  text-decoration: underline;
}
</style>
